import * as React from "react";

export const ShortcutTasksIcon = (props: any) => (
  <svg
    width={39}
    height={32}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.781 5.281 7.5 8.594 6.219 7.28 4.78 8.72 7.5 11.406l4.719-4.687L10.78 5.28ZM14.5 7v2h14V7h-14Zm0 8v2h14v-2h-14Zm0 8v2h14v-2h-14Z"
      fill="#2D5BFF"
    />
  </svg>
);
